import renderColorImage from "./renderColorImage.js";
import renderGrayscaleImage from "./renderGrayscaleImage.js";

// import crossVectors from "../MPR/vtk/math/crossVectors";
// import determineOrientation from "../MPR/vtk/utils/determineOrientation";
// import computeZAxis from "../MPR/vtk/utils/computeZAxis";
// import getTypedPixelArray from "../MPR/vtk/utils/getTypedPixelArray";
// import getSliceIndex from "../MPR/vtk/utils/getSliceIndex";
// import insertSlice from "../MPR/vtk/utils/insertSlice";
// import mapVtkSliceToOurImage from "../MPR/vtk/utils/mapVtkSliceToOurImage";
/** VTK.JS Adapter */

/**
 * Draw an image to a given enabled element synchronously
 *
 * @param {EnabledElement} enabledElement An enabled element to draw into
 * @param {Boolean} invalidated - true if pixel data has been invalidated and cached rendering should not be used
 * @returns {void}
 * @memberof Internal
 */
function drawImageSync(enabledElement, image, invalidated) {
  //let image = enabledElement.image;
  //const { imageOrientation } = enabledElement.viewport;
  const imageOrientation = [0, 1, 0, 0, 0, -1];
  //const element = enabledElement.element;
  const layers = enabledElement.layers || [];

  // Check if enabledElement can be redrawn
  if (
    !enabledElement.canvas ||
    !(enabledElement.image || layers.length || image)
  ) {
    return;
  }

  image.stats = {
    lastGetPixelDataTime: -1.0,
    lastStoredPixelDataToCanvasImageDataTime: -1.0,
    lastPutImageDataTime: -1.0,
    lastRenderTime: -1.0,
    lastLutGenerateTime: -1.0,
  };

  if (image) {
    let render = image.render;
    if (!render) {
      if (image.color) {
        render = renderColorImage;
      } else {
        render = renderGrayscaleImage;
      }
    }

    //render(enabledElement, invalidated);
    render(enabledElement, invalidated, image);
  }

  //image.stats.lastRenderTime = renderTimeInMs;

  enabledElement.invalid = false;
  enabledElement.needsRedraw = false;
}

export default drawImageSync;
